module.exports = "https://www.gc-pro.gnp.com.mx/f441be71f10fa663050a06617006f510.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/siniestros-rembolsos.svg
// module id = 1861
// module chunks = 0